import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card",
  id: "kt_timeline_widget_2_card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header position-relative py-0 border-bottom-2" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-stretch nav-pills nav-pills-custom d-flex mt-3",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted active px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_1",
        "aria-selected": "true",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-4 mb-3" }, " Documents "),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_2",
        "aria-selected": "false",
        tabindex: "-1",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-4 mb-3" }, "Owner Details"),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_3",
        "aria-selected": "false",
        tabindex: "-1",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-4 mb-3" }, "Business Details"),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "kt_timeline_widget_2_tab_1",
  role: "tabpanel"
}
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-10px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-25px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-400px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-100px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-125px" })
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", {
    "data-kt-element": "bullet",
    class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      value: "",
      "data-kt-element": "checkbox",
      disabled: ""
    })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-gray-800 text-hover-primary fw-bold fs-6"
  }, "Account Verification"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Voided Check with business / pesonal account")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "data-kt-element": "status",
    class: "badge badge-light-primary"
  }, "In Process")
], -1)
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "d-flex justify-content-start flex-shrink-0" }
const _hoisted_15 = {
  class: "dropzone p-1",
  ref: "dropRef"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "dz-message needsclick" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ms-2 mt-1 me-2" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fs-8 fw-normal text-gray-900 mb-0" }, " Upload or Drag File ")
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", {
    "data-kt-element": "bullet",
    class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      value: "",
      "data-kt-element": "checkbox",
      disabled: ""
    })
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-gray-800 text-hover-primary fw-bold fs-6"
  }, "ID Verification"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Drivers License / Passport / Gov't issued")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "data-kt-element": "status",
    class: "badge badge-light-primary"
  }, "In Process")
], -1)
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "d-flex justify-content-start flex-shrink-0" }
const _hoisted_24 = {
  class: "dropzone p-1",
  ref: "dropRef"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "dz-message needsclick" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ms-2 mt-1 me-2" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fs-8 fw-normal text-gray-900 mb-0" }, " Upload or Drag File ")
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("span", {
      "data-kt-element": "bullet",
      class: "bullet bullet-vertical d-flex align-items-center h-40px bg-success"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-success form-check-solid" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input",
        type: "checkbox",
        value: "",
        checked: "",
        "data-kt-element": "checkbox",
        disabled: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-800 text-hover-primary fw-bold fs-6"
    }, "Bank Statements"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Previous 90 days of business / personal statements")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
    /*#__PURE__*/_createElementVNode("span", {
      "data-kt-element": "status",
      class: "badge badge-light-success"
    }, "Completed")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start flex-shrink-0" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "p-1" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-check text-success fs-1" })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("span", {
      "data-kt-element": "bullet",
      class: "bullet bullet-vertical d-flex align-items-center h-40px bg-success"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-success form-check-solid" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input",
        type: "checkbox",
        value: "",
        checked: "",
        "data-kt-element": "checkbox",
        disabled: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-800 text-hover-primary fw-bold fs-6"
    }, "Address Verification"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Business License / Utility Bill")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
    /*#__PURE__*/_createElementVNode("span", {
      "data-kt-element": "status",
      class: "badge badge-light-success"
    }, "Completed")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start flex-shrink-0" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "p-1" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-check text-success fs-1" })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_timeline_widget_2_tab_2",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "table align-middle gs-0 gy-4" }, [
      /*#__PURE__*/_createElementVNode("thead", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-10px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-25px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-400px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-100px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-125px" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-success"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-success form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                checked: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Book p. 77-85, read & complete tasks 1-6 on p. 85"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Physics")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-success"
            }, "Done")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Workbook p. 17, tasks 1-6"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Mathematics")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-primary"
            }, "In Process")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-success"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-success form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                checked: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Learn paragraph p. 99, Exercise 1,2,3Scoping & Estimations"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Chemistry")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-success"
            }, "Done")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Write essay 1000 words “WW2 results”"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "History")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-primary"
            }, "In Process")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_timeline_widget_2_tab_3",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "table align-middle gs-0 gy-4" }, [
      /*#__PURE__*/_createElementVNode("thead", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-10px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-25px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-400px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-100px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-125px" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Workbook p. 17, tasks 1-6"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Mathematics")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-primary"
            }, "In Process")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-success"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-success form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                checked: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Learn paragraph p. 99, Exercise 1,2,3Scoping & Estimations"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "Chemistry")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-success"
            }, "Done")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Write essay 1000 words “WW2 results”"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "History")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-primary"
            }, "In Process")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-printer fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm me-3"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-chat fs-3" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-color-muted btn-bg-light btn-active-color-primary btn-sm"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fonticon-paperclip fs-3" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "bullet",
              class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid" }, [
              /*#__PURE__*/_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                "data-kt-element": "checkbox"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-gray-800 text-hover-primary fw-bold fs-6"
            }, "Internal conflicts in Philip Larkin poems, read p 380-515"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-7 d-block" }, "English Language")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", {
              "data-kt-element": "status",
              class: "badge badge-light-primary"
            }, "In Process")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end flex-shrink-0" })
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _hoisted_17, 512)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _hoisted_26, 512)
                    ])
                  ])
                ]),
                _hoisted_27,
                _hoisted_28
              ])
            ])
          ])
        ]),
        _hoisted_29,
        _hoisted_30
      ])
    ])
  ]))
}